import React from "react";
import "./accountHistory.css";

const AccountHistory = () => {
  return (
    <>
      <div className="accountHisPage">
        <div class="account-history">
          <h2>Account History</h2>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Transaction Type</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="4" class="no-transactions">
                  No transactions found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AccountHistory;
